<style lang='less'>
*{
    padding:0;margin:0;
}
.swiper-pagination-bullet{
    width:6px !important;
    height:6px !important;
}
#app{
    -webkit-font-smoothing:antialiased;
    -moz-osx-font-smoothing:grayscale;
    margin-top:80px;

}
body{
    min-width:1080px;
    overflow-x:hidden;
    background:rgb(246,246,246);
    font-family: "Microsoft YaHei",PingFangSC-Regular,"PingHei", Helvetica, STHeiTi, Arial, sans-serif;
}

.page{
    .inner{
        overflow:hidden;
        min-width:1080px;
        width:1080px;
        margin:0 auto;
        position:relative;
        height:100%;
    }
}
</style>
<template>
    <div id="app">
        <common-header/>
        <transition name="fade" mode="out-in">
            <router-view></router-view>
        </transition>
        <common-footer/>
    </div>
</template>
<script>
    import CommonHeader from './Components/Header.vue';
    import CommonFooter from './Components/Footer.vue';

    export default {
        components: {
            CommonHeader,
            CommonFooter,
        },
    };
</script>



// WEBPACK FOOTER //
// App.vue?5b1430aa